import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { TrendingUp, TrendingDown, Radio } from "lucide-react";

export default function LiveTicker() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    let active = true;
    const load = async () => {
      try {
        const { data } = await api.get("/ticker");
        if (active) setItems(data || []);
      } catch {
        /* ticker is non-critical */
      }
    };
    load();
    const t = setInterval(load, 60000);
    return () => {
      active = false;
      clearInterval(t);
    };
  }, []);

  if (!items.length) return null;
  const loop = [...items, ...items];

  return (
    <div className="ticker-wrap bg-black border-y border-smasher-gold/20 overflow-hidden" data-testid="live-ticker">
      <div className="ticker-track py-2">
        {loop.map((it, i) => (
          <span key={i} className="inline-flex items-center gap-2 px-5 border-r border-white/5 font-mono-num text-sm">
            {it.status === "live" ? (
              <span className="inline-flex items-center gap-1 text-emerald-400">
                <Radio className="w-3.5 h-3.5 live-dot" /> LIVE
              </span>
            ) : (
              <span className="text-slate-500 text-xs">FINAL</span>
            )}
            <span className="text-smasher-gold font-bold">{it.league}</span>
            <span className="text-white">{it.label}</span>
            {it.change >= 0 ? (
              <TrendingUp className="w-3.5 h-3.5 text-emerald-400" />
            ) : (
              <TrendingDown className="w-3.5 h-3.5 text-red-500" />
            )}
          </span>
        ))}
      </div>
    </div>
  );
}
